export default [
    {
        path: 'bairro',
        component: () => import(
            /* webpackChunkName: 'cadastro-bairro' */
            '@/views/cadastro/bairro/Index'
        ),
        redirect: 'bairro/index',
        children: [
            {
                name: 'cadastro-bairro-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'cadastro-bairro' */
                    '@/views/cadastro/bairro/List.vue'
                ),
            },
            {
                name: 'cadastro-bairro-create',
                path: 'create',
                component: () => import(
                    /* webpackChunkName: 'cadastro-bairro' */
                    '@/views/cadastro/bairro/Form.vue'
                ),
            },
            {
                name: 'cadastro-bairro-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(
                    /* webpackChunkName: 'cadastro-bairro' */
                    '@/views/cadastro/bairro/Form.vue'
                ),
            },
        ],
    },
]